import React from 'react';
import PropTypes from 'prop-types';
import { isExpired } from '@/utils/dateTimeUtils';
import HiddenTag from '@/components_cards/tags/_resource/HiddenTag';
import MissingFieldsTag from '@/components_cards/tags/MissingFieldsTag';
import CancelledTag from '@/components_cards/tags/_resource/CancelledTag';
import CompletedTag from '@/components_cards/tags/_resource/CompletedTag';
import ExpiredTag from '@/components_cards/tags/_resource/ExpiredTag';
import useMissingFields from '@/pages/offer-manage/useMissingFields';

export default function StatusTags(props) {
  const { offer } = props;

  const { missingFields } = useMissingFields(offer);

  if (offer.data.cancelled) {
    return (
      <div className="flex space-x-4">
        <CancelledTag resource={offer} />
        {!offer.data.published && (
          <HiddenTag resource={offer} />
        )}
      </div>
    );
  }

  if (offer.data.completed) {
    return (
      <div className="flex space-x-4">
        <CompletedTag resource={offer} />
        {!offer.data.published && (
          <HiddenTag resource={offer} />
        )}
      </div>
    );
  }

  const expired = isExpired(offer.data.endDate);

  if (
      expired ||
      !offer.data.published ||
      missingFields.data.length > 0
  ) {
    return (
      <div className="flex space-x-4">
        {expired && (
          <ExpiredTag resource={offer} />
        )}
        {!offer.data.published && (
          <HiddenTag resource={offer} />
        )}
        {missingFields.data.length > 0 && (
          <MissingFieldsTag resource={offer} />
        )}
      </div>
    );
  }

  return null;
}

StatusTags.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      cancelled: PropTypes.bool,
      completed: PropTypes.bool,
      published: PropTypes.bool,
      endDate: PropTypes.string
    })
  }).isRequired
};
